// eslint-disable-next-line
import { default as router, checkLogin } from '@/router/index.js'
import store from '@/store/index.js'
// import storeModule from './storeModule'

import SxswIndex from './views/SxswIndex.vue'
// import EmailDetail from './EmailDetail.vue'

const addon = {
  // $socket: null,
  $router: router,
  $store: store,

  install (Vue, params) {
    // this.$socket = params.socket

    // register store module
    // this.$store.registerModule('emails', storeModule)

    // add routes to router
    this.$router.addRoute(
      {
        path: '/sxsw',
        component: SxswIndex,
        beforeEnter: checkLogin
      }
    )

    // add navItems to top level nav
    const navItem = { to: '/sxsw', label: 'Sxsw' }
    this.$store.dispatch('nav/addToNav', navItem)

    // connect socket to store
    // if (this.$socket) {
    //   this.$socket.on('/emails/get/all', this.handleEmailsResponse.bind(this))
    //   // add fill store on connect
    //   this.$socket.on('connect', () => {
    //     this.$socket.emit('/emails/get/all', { token: this.token }, this.handleEmailsResponse.bind(this))
    //   })
    // }
  }

  // pass response from backend to store
  // handleEmailsResponse (response) {
  //   if (response && response.status && response.status.code === 200) {
  //     if (response.data) {
  //       this.$store.dispatch('replaceEmails', response.data)
  //     }
  //   } else {
  //     console.log('Emails response error', response)
  //   }
  // }
}

export default addon
